import config from '../../config/config';

export const PAYOUT_FAILURE = 'PAYOUT/PAYOUT_FAILURE';
export const PAYOUT_LOAD = 'PAYOUT/PAYOUT_LOAD';
export const PAYOUT_SUCCESS = 'PAYOUT/PAYOUT_SUCCESS';

export function getPayout(payoutId) {
    return {
        failureActionTypeOrCreator: getPayoutFailureActionCreator,
        fetchParams: {
            url: `${config.payoutApiUrl}/${payoutId}`
        },
        loadActionTypeOrCreator: PAYOUT_LOAD,
        successActionTypeOrCreator: getPayoutSuccessActionCreator
    };
}

export function getPayoutFailureActionCreator(error) {
    return {
        error,
        type: PAYOUT_FAILURE
    };
}

export function getPayoutSuccessActionCreator(payout) {
    return {
        payout,
        type: PAYOUT_SUCCESS
    };
}
